<template>
  <v-card :disabled="isProcessing" :loading="isProcessing">
    <template v-slot:progress>
      <v-progress-linear
        absolute
        color="success"
        height="4"
        indeterminate
      ></v-progress-linear>
    </template>
    <v-tabs v-model="tab" class="crm-color" left dark icons-and-text>
      <v-tabs-slider></v-tabs-slider>
      <v-tab href="#tab-1">
        <v-toolbar-title>{{ $t("DEAL_STATUSES.TITLE") }}</v-toolbar-title>
      </v-tab>
      <v-spacer></v-spacer>
      <div class="buttons-tab">
        <v-btn
          v-if="hasPermissions('deal-statuses-create')"
          class="mr-4 success"
          :disabled="isProcessing"
          @click="handleCreateClick"
        >
          {{ $t("GENERAL.LABELS.CREATE_BUTTON") }}
        </v-btn>
      </div>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item value="tab-1">
        <v-card flat>
          <v-card-text class="pa-0">
            <Table
              v-if="userStatePrepared"
              ref="deal-statuses-table"
              height="500"
              name="deal-statuses-table"
              :headers="headers"
              :blink-row-item-key="blinkRowItemKey"
              :server-data-options="{
                method: tableItemsMethod,
              }"
              :items-per-page="100"
              :loading="isProcessing"
              dense
              fixed-header
              multi-sort
              filterable
            >
              <template
                v-for="(header, index) in headers"
                v-slot:[`item.${header.value}`]="{ item }"
              >
                <span
                  v-if="header.value === 'options'"
                  :key="index"
                  class="d-flex align-center justify-center flex-nowrap"
                >
                  <v-btn
                    icon
                    color="indigo"
                    :to="{ name: 'deal-statuses-view', params: { id: item.item.id } }"
                    @click="rememberTableRow(item.item.id)"
                  >
                    <v-icon dark>mdi-eye</v-icon>
                  </v-btn>
                </span>
                <template v-else-if="header.value === 'is_system'">
                  <v-chip
                    :key="index"
                    x-small
                    :color="item.value ? 'primary' : 'grey'"
                    dark
                  >
                    {{
                      item.value
                        ? $t("DEAL_STATUSES.SYSTEM")
                        : $t("DEAL_STATUSES.CUSTOM")
                    }}
                  </v-chip>
                </template>
                <template v-else>
                  {{ item.value || "-" }}
                </template>
              </template>
            </Table>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import Table from "@/views/partials/v-table/Table.vue";
import userStateService from "@/common/userState.service.js";
import { GET_DEAL_STATUSES } from "@/store/dealStatuses.module";

export default {
  name: "ListDealStatuses",
  components: {
    Table,
  },
  data() {
    return {
      tableName: "deal-statuses-table",
      blinkRowItemKey: null,
      userStatePrepared: false,
      tab: "tab-1",
      isProcessing: false,
      tableItemsMethod: GET_DEAL_STATUSES,
      headers: [
        {
          text: "#",
          value: "id",
          align: "center",
          width: "8%",
        },
        {
          text: this.$t("GENERAL.LABELS.NAME"),
          value: "name",
          align: "center",
          width: "32%",
        },
        {
          text: this.$t("DEAL_STATUSES.SLUG"),
          value: "slug",
          align: "center",
          width: "25%",
        },
        {
          text: this.$t("DEAL_STATUSES.TYPE"),
          value: "is_system",
          align: "center",
          width: "15%",
        },
        {
          text: this.$t("GENERAL.TABLE.OPTIONS_COLUMN"),
          value: "options",
          sortable: false,
          align: "center",
          width: "20%",
        },
      ],
    };
  },
  mounted() {
    this.blinkRowItemKey = userStateService.getState(
      `table-state.${this.tableName}.blinkRowItemKey`,
      null
    );
    this.userStatePrepared = true;
  },
  methods: {
    handleCreateClick() {
      this.$router.push({ name: "deal-statuses-create" });
    },
    rememberTableRow(id) {
      userStateService.setState(
        `table-state.${this.tableName}.blinkRowItemKey`,
        id
      );
    },
  },
};
</script>
